module.exports = __webpack_public_path__ + "static/media/empty-calendar.32f832cd.svg";